export type { DialogProps } from '../../types/dialog';
export { Dialog } from './adapters/inbound/Dialog';
